import { baseApi } from "./api";
import request from "../request";

export const projectPlanningApi = baseApi.injectEndpoints({
	endpoints: (build) => ({
		getProjectPlanning: build.query({
			query: (projectId) => ({
				url: `/projects/${projectId}/planning`,
			}),
			providesTags: (_result, _error, projectId) => [
				{ type: "ProjectPlanning", id: projectId },
			],
		}),
		updateProjectPlanning: build.mutation({
			query: ({ projectId, planningData }) => ({
				url: `/projects/${projectId}/planning`,
				method: "PUT",
				body: { planningData },
			}),
			invalidatesTags: (_result, _error, { projectId }) => [
				{ type: "ProjectPlanning", id: projectId },
			],
		}),
		updatePlanningEntry: build.mutation({
			query: ({ projectId, planningId, ...body }) => ({
				url: `/projects/${projectId}/planning/${planningId}`,
				method: "PUT",
				body,
			}),
			invalidatesTags: (_result, _error, { projectId }) => [
				{ type: "ProjectPlanning", id: projectId },
			],
		}),
		deletePlanningEntry: build.mutation({
			query: ({ projectId, planningId }) => ({
				url: `/projects/${projectId}/planning/${planningId}`,
				method: "DELETE",
			}),
			invalidatesTags: (_result, _error, { projectId }) => [
				{ type: "ProjectPlanning", id: projectId },
			],
		}),
		initializePlanning: build.mutation({
			query: (projectId) => ({
				url: `/projects/${projectId}/planning/initialize`,
				method: "POST",
			}),
			invalidatesTags: (_result, _error, projectId) => [
				{ type: "ProjectPlanning", id: projectId },
			],
		}),
	}),
});

export const {
	useGetProjectPlanningQuery,
	useUpdateProjectPlanningMutation,
	useUpdatePlanningEntryMutation,
	useDeletePlanningEntryMutation,
	useInitializePlanningMutation,
} = projectPlanningApi;

export const downloadPlanningPdf = async (projectId, language = "de") => {
	try {
		const config = {
			responseType: "blob",
			headers: {
				Accept: "application/pdf",
			},
		};

		const response = await request.get(
			`/projects/${projectId}/planning/download?lang=${language}`,
			config,
		);

		const blob = new Blob([response], { type: "application/pdf" });
		const url = window.URL.createObjectURL(blob);
		const link = document.createElement("a");
		link.href = url;
		link.setAttribute("download", `planning-${projectId}.pdf`);
		document.body.appendChild(link);
		link.click();
		link.remove();
		window.URL.revokeObjectURL(url);

		return response;
	} catch (error) {
		console.error("Error downloading planning PDF:", error);
		throw new Error(error?.message || "Error downloading planning PDF");
	}
};
